import { ChangeDetectionStrategy, Component, input } from '@angular/core';

let instanceCounter = 0;

@Component({
  selector: 'app-thumbnail-glow-svg',
  standalone: true,
  template: `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.8" cx="16" cy="16" r="16" [attr.fill]="'url(#' + gradientId + ')'"/>
      <defs>
        <radialGradient [attr.id]="gradientId" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(16 16) rotate(90) scale(16)">
          <stop [attr.stop-color]="color()"/>
          <stop offset="1" [attr.stop-color]="color()" stop-opacity="0"/>
        </radialGradient>
      </defs>
    </svg>
  `,
  styles: [`
    :host {
      display: block;
      width: 32px;
      height: 32px;
      position: absolute;
    }
    svg {
      display: block;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThumbnailGlowSvgComponent {
  readonly color = input.required<string>();
  readonly gradientId = `thumbnail_glow_${++instanceCounter}`;
}
